import { Pipe, PipeTransform } from '@angular/core';

const PARTS = [
    { v: 60 * 60 * 24 * 365, s: 'г' },
    { v: 60 * 60 * 24 * 30, s: 'мес' },
    { v: 60 * 60 * 24 , s: 'д' },
    { v: 60 * 60, s: 'ч' },
    { v: 60, s: 'м' },
]

@Pipe({ name: 'duration' })
export class DurationPipe implements PipeTransform {

    transform(value: any, withSuffix = true, space = '', withSeconds = false, nullValue?: string): any {
        if (value === undefined || value === null || isNaN(value)) {
            if (nullValue === undefined) {
                value = 0;
            }
            else {
                return nullValue;
            }
        }
        value = +value;
        const res = [];
        for (const p of PARTS) {
            if (value >= p.v) {
                const v = Math.trunc(value / p.v);
                res.push('' + v + (withSuffix ? space + p.s : ''));
                value -= v * p.v;
            }
            if (value <= 0) {
                break;
            }
        }
        if (value > 0) {
            if (withSeconds) {
                res.push('' + value + (withSuffix ? space + 'с' : ''));
            }
        }
        return res.length ? res.join(' ') : 'меньше минуты';
    }

}
